const messages = {
  placeholder: {
    id: 'admin/promotions.form.scope.categories.select.placeholder',
  },
  label: {
    id: 'admin/promotions.form.scope.categories.select.label',
  },
}

export default messages
